import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { SimpleHeader } from '@/components/layout/SimpleHeader';
import Footer from '@/components/layout/Footer';
import { SidebarProvider } from '@/components/ui/sidebar';
import { CommandPalette } from '@/components/shared/CommandPalette';
import { useCommandPalette } from '@/hooks/useCommandPalette';
// import EnhancedChatWidget from '@/components/chat/EnhancedChatWidget';
// import SimpleChatWidget from '@/components/chat/SimpleChatWidget';
import ChatWidget from '@/components/chat/ChatWidget';
import { useAuth } from '@/contexts/AuthContext';
// import { useRenderTracking, EmergencyBailoutUI } from '@/utils/performanceMonitor.tsx';

// Industry Standard: Route-based chat widget management
const ChatWidgetManager = React.memo(() => {
  const location = useLocation();
  const { user } = useAuth();
  
  // FIXED: Don't show customer chat on ANY admin page (not just chat-management)
  const isAdminPage = location.pathname.startsWith('/admin');
  const shouldShowCustomerChat = user && !isAdminPage;
  
  // DISABLED: Debug logging causing infinite re-render loop
  // console.log('[admin-user-chat] ChatWidgetManager render:', {
  //   pathname: location.pathname,
  //   hasUser: !!user,
  //   isAdminPage,
  //   shouldShowCustomerChat,
  //   willRenderCustomerChat: shouldShowCustomerChat,
  //   timestamp: Date.now()
  // });
  
  return shouldShowCustomerChat ? <ChatWidget key="customer-chat" /> : null;
});

// JHAKKAS FIX: Layout implementation with emergency safeguards
const LayoutImpl = () => {
  const { user } = useAuth();
  // const { shouldBailout, renderCount, resetMetrics } = useRenderTracking('Layout');
  const { isOpen, closePalette } = useCommandPalette({
    enableShortcut: true,
    preventDefaultShortcuts: true,
  });

  // EMERGENCY BAILOUT: Disabled per user request
  // if (shouldBailout) {
  //   console.error('[admin-user-chat] 🚨 Layout EMERGENCY BAILOUT triggered!');
  //   return (
  //     <EmergencyBailoutUI 
  //       componentName="Layout" 
  //       renderCount={renderCount}
  //       onReset={() => {
  //         resetMetrics();
  //         window.location.reload();
  //       }}
  //     />
  //   );
  // }

  // Debug logging disabled with performance monitoring
  // console.log('[admin-user-chat] 🏗️ Layout render:', {
  //   userExists: !!user,
  //   commandPaletteOpen: isOpen,
  //   timestamp: Date.now()
  // });

  return (
    <SidebarProvider>
      <div className="flex flex-col min-h-screen w-full bg-white">
        <SimpleHeader />
        <main className="flex-grow bg-white">
          <Outlet />
        </main>
        <Footer />

        {/* Global Command Palette */}
        <CommandPalette isOpen={isOpen} onClose={closePalette} />
        
        {/* Industry Standard: Smart Chat Widget Management - Hidden on admin chat pages */}
        <ChatWidgetManager key="chat-widget-manager" />
      </div>
    </SidebarProvider>
  );
};

// JHAKKAS FIX: Enhanced React.memo with custom comparison for Layout
const layoutMemoComparison = (prevProps: any, nextProps: any) => {
  
  // Since Layout has no props, we can always block re-renders from parent
  // All routing and state changes are handled internally via hooks
  console.log('[admin-user-chat] 🛑 Layout memo: BLOCKING re-render (no external props)');
  return true; // Always return true = never re-render due to parent changes
};

// Export the memoized Layout with emergency safeguards
export const Layout = React.memo(LayoutImpl, layoutMemoComparison);

Layout.displayName = 'Layout';

export default Layout;
